import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { logIn, logOut } from '../app-context/user'
import { LoginModel } from '../models/LoginModel';
import { EmailsModel } from '../models/EmailsModel';
import { SimulatorModel } from '../models/SimulatorModel';


const LoginPopup = () => {
    const dispatch = useDispatch();
    const loginModel:LoginModel = new LoginModel();
    const emailsModel: EmailsModel = new EmailsModel();

    const [userName, setUserName] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [savedUser, setSavedUser] = useState<any | null>(null)
    const [inValidLogin, setInvalidLogin] = useState<boolean>(false);
    const [inActiveUser, setInActiveUser] = useState<boolean>(false);

    
    const onUserNameChange = (event: any) => {
        setUserName(event.target.value)
    }
    const onUserPasswordChange = (event: any) => {
        setUserPassword(event.target.value)
    }

    

    const loadMailSettings = async () => {
        const emailSettings:any = await emailsModel.getEmailsSettings();
        
        emailSettings.emails.forEach(async (emailAccount: any) => {
            const folders = await emailsModel.getFolders(emailAccount.id);
            localStorage.setItem(`emailAccount_${emailAccount.id}`, JSON.stringify(folders));
        });
        
        return emailSettings;
    }

    const onLoginClick = async () => {
        console.log('onLoginClick');
        const userDataStr = localStorage.getItem('loggedUser');
        let currUser: any | null = null;
        if (userDataStr) {
            currUser = JSON.parse(userDataStr);
            await setSavedUser(JSON.parse(userDataStr));
            // if (loginModel.isAuthTokenSaved()) {
            //     console.log('init App -> found logged user')
            //     navigate(`/Leads`);
            // }
        }
        if (userName !== '' && userPassword !== '') {
            const loginData = await loginModel.loginUser(
                {
                    UserName: userName,
                    Password: userPassword
                }
            )
            console.log('loginData', loginData);
            if (loginData && loginData.token && loginData.status == 0) {
                await localStorage.setItem('AuthToken', loginData.token);
                if (currUser && currUser.id && currUser.id == loginData.user.id) {
                    // if (savedUser.id !== loginData.id) {
                    //     loginModel.clearSavedUserData();
                    // }
                } else {
                    loginModel.clearSavedUserData();
                    const emailSettings = await loadMailSettings();
                    localStorage.setItem('emailSettings', JSON.stringify(emailSettings));
                    const simulatorModel:SimulatorModel = new SimulatorModel();
                    simulatorModel.getAddressesAll();
                }

                const userMenuPermissions = await loginModel.userGetRoles();
                localStorage.setItem('loggedUser', JSON.stringify({
                    email: loginData.user.email,
                    name: loginData.user.name,
                    id: loginData.user.id,
                    role: loginData.role,
                    menuPermissions: userMenuPermissions,
                    branchName: loginData.branchName
                }));

                localStorage.setItem('isAdminUser', (loginData.role==0)+"");

                dispatch(logIn())
            } else {
                if(loginData.status == 1) {
                    setInActiveUser(true)
                } else {
                    setInvalidLogin(true)
                }
            }
        }
    }

    const onInputFocus = () => {
        setInvalidLogin(false);
    }


    const emptyFunc = () => {}

    useEffect(()=> {
        const userDataStr = localStorage.getItem('loggedUser');
        setUserPassword('')
        let currUser: any | null = null;
        if (userDataStr) {
            currUser = JSON.parse(userDataStr);
            setSavedUser(currUser);
            setUserName(currUser.email);
        }
    }, [])
    
    return ( <>
        <div className={`popup-wrapper add-login-popup`}>
            <section className="popup-window rtl">
                <div className='login-inner'>
                    <div className='logo-row'>
                        <div className='logo'></div>
                    </div>
                    <div className='login-form-holder'>
                        <div className='login-form-row'>
                            <div className='input-field'>
                                <div className='label'>
                                    אימייל
                                </div>
                                <div className='input'>
                                    <input type='text' autoComplete={'off'} placeholder='' value={userName} onChange={onUserNameChange} onFocus={onInputFocus} />
                                </div>
                            </div>
                        </div>
                        <div className='login-form-row'>
                            <div className='input-field'>
                                <div className='label'>
                                    סיסמה
                                </div>
                                <div className='input'>
                                    <input type='password' autoComplete={'off'} placeholder='' value={userPassword} onChange={onUserPasswordChange} onFocus={onInputFocus} />
                                </div>
                            </div>
                        </div>
                        {inValidLogin && <div className='login-form-row flex-justify-center'>
                            <div className='error-message'>שם משתמש או סיסמא שגויים</div>
                        </div>}
                        {inActiveUser && <div className='login-form-row flex-justify-center'>
                            <div className='error-message'>משתמש לא פעיל</div>
                            </div>}
                        <div className='login-form-row buttons-row'>
                            <button
                                className='login-form-btn button blue flex-centered flex-justify-center'
                                onClick={onLoginClick}
                            >
                                כניסה
                            </button>
                            
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>  
        
    );
}
export default LoginPopup;